export default function ({ store, app, route }) {
  const localeList = ['en-ca', 'fr-ca', 'en-us', 'en-eu', 'fr-eu']
  let lang = route.fullPath.split('/')[1]
  if (!localeList.some(lang)) lang = 'en-us'
}
